import { render } from "./Source.vue?vue&type=template&id=7bc6a8f4&scoped=true&ts=true"
import script from "./Source.vue?vue&type=script&lang=ts"
export * from "./Source.vue?vue&type=script&lang=ts"

import "./Source.vue?vue&type=style&index=0&id=7bc6a8f4&lang=scss&scoped=true"

import exportComponent from "/home/app/mt-partners/frontend/affiliate/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bc6a8f4"]])

export default __exports__